(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[294,220],{

/***/ 45455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Scripts; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./providers/Scripts/useGoogleAdsSettings/index.tsx


var versions = {
  opopular: '2.7',
  tocantins: '2.1',
  daqui: '2.1',
  cbngo: '1.0'
};
function useGoogleAdsSettings(_ref) {
  var enabled = _ref.enabled,
      slug = _ref.slug;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/ads-slots-settings-".concat(slug, ".js?v=").concat(versions[slug])
    }, 'google-ads-settings')
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useGoogleTagManager/index.tsx



function useGoogleTagManager(_ref) {
  var enabled = _ref.enabled,
      code = _ref.code,
      slug = _ref.slug;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [slug !== 'tocantins' && /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      src: "https://tagmanager.alright.network/manager/js/container_IPxf9GaY.js"
    }), code && /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "https://www.googletagmanager.com/gtm.js?id=".concat(code)
    }, 'google-tag-manager')]
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useGoogleTagServices/index.tsx


function useGoogleTagServices(_ref) {
  var enabled = _ref.enabled;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
    }, 'google-tag-services')
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useGoogleTagEvents/index.tsx


function useGoogleTagEvents(_ref) {
  var enabled = _ref.enabled;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/gtm-events.js?v=1.8"
    }, 'google-tag-events')
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useUtilsOjc/index.tsx


function useUtilsOJC(_ref) {
  var enabled = _ref.enabled;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/utils-ojc.js?v=1.0"
    }, 'ojc-utils')
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useChartbeatSettings/index.tsx


function useChartbeatSettings(_ref) {
  var enabled = _ref.enabled;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/chartbeat-settings.js?v=1.2"
    }, 'chartbeat-settings')
  });
}
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
;// CONCATENATED MODULE: ./providers/Scripts/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */
// import { initAnalytics } from "hooks/useGCJAnalytics";











var tagManagerId = "GTM-TB9XSFX" || 0;
var slug = "cbngo" || 0;

var ScriptsProvider = function ScriptsProvider(_ref) {
  var children = _ref.children;
  var cookies = (0,dist.parseCookies)();
  var sessionData = JSON.parse(cookies.sessionData || "{}"); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
  // quando confirmado a migração, remover.
  // useEffect(() => {
  //   initAnalytics(
  //     process.env.NEXT_PUBLIC_SITE_ID_ANALYTICS,
  //     process.env.NEXT_PUBLIC_CONTENTID_ANALYTICS,
  //     sessionData?.emailUsuario
  //   );
  // }, []);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [useGoogleTagManager({
        enabled: true,
        code: tagManagerId,
        slug: slug
      }), useGoogleTagServices({
        enabled: true
      }), useGoogleAdsSettings({
        enabled: true,
        slug: slug
      }), useGoogleTagEvents({
        enabled: true
      }), useUtilsOJC({
        enabled: true
      }), useChartbeatSettings({
        enabled: true
      })]
    }), children, /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/push-news.js"
    }, "push-news")]
  });
};

/* harmony default export */ var Scripts = (ScriptsProvider);

/***/ }),

/***/ 59159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57083);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  var serverSideContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_0__.ServerSidePropsContext);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "ThemeProvider ".concat(serverSideContext.siteConfig.theme.className),
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ThemeProvider);

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

}]);